"use client";

import * as React from "react";
import { format } from "date-fns";
import { cn } from "utils";

export function DateTimePicker({
  value,
  onChange,
  className,
  disabled,
  disableDates,
  ...props
}) {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val) {
      const localDate = new Date(val);
      onChange?.(localDate);
    } else {
      onChange?.(null);
    }
  };

  let dateStr = "";
  if (value) {
    try {
      const d = new Date(value);
      if (!isNaN(d.getTime())) {
        dateStr = format(d, "yyyy-MM-dd'T'HH:mm");
      }
    } catch (e) {
      // ignore
    }
  }

  return (
    <input
      type="datetime-local"
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        "relative [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-3 [&::-webkit-calendar-picker-indicator]:cursor-pointer",
        !dateStr && "text-muted-foreground",
        className
      )}
      value={dateStr}
      onChange={handleChange}
      disabled={disabled}
      {...props}
    />
  );
}